import $localStorage from "@/utils/localStorage";
import { xxUrlParams } from "@/utils/getUrlParam";

const xxShopType = $localStorage.get("xxShopType");
export default {
	data() {
		return {
			type:'package'
		};
	},
	created(){
		if(xxUrlParams.type){
			this.type = xxUrlParams.type;
			$localStorage.set('xxShopType',xxUrlParams.type);
		}else if(xxShopType){
			this.type =  xxShopType;
		}
	},
	methods:{
		setType(type = 'package'){
			$localStorage.set('xxShopType',type);
		}
	}
};

// type
// 外卖package/堂食canteen/自提personal/CEO 套餐level=10&type=package
